// Re-export the properly configured API client from config
import apiClient from '../api/config';

export { apiClient as api };
export default apiClient;